import { PdfViewerModule } from '@syncfusion/ej2-angular-pdfviewer';
import {NgModule} from '@angular/core';
import { PdfEditorLegacyComponent } from './components/pdf-editor-legacy.component';
import { FormsModule } from '@angular/forms';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';


@NgModule({
  imports: [PdfViewerModule, FormsModule, AppButtonModule, FontAwesomeModule, CommonModule, MatTooltipModule],
    declarations: [PdfEditorLegacyComponent],
    exports: [
        PdfEditorLegacyComponent,
    ],
})
export class PdfEditorLegacyModule {
}
